import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WebsocketService } from '@app/shared/websocket/websocket.service';
import { AlertService } from '@app/shared/components/organisms/alert/alert.service';

@Injectable({
  providedIn: 'root',
})
export class WebsocketInformationsService {
  constructor(
    private websocketService: WebsocketService,
    private alertService: AlertService,
    private router: Router,
  ) {
    this.listenParamsUpdated();
    this.listenAlertsUpdated();
    this.listenContractsUpdated();
  }

  refreshNow() {
    window.location.reload();
  }

  private listenParamsUpdated() {
    this.websocketService.onParamsUpdated().subscribe(() => {
      const allowedRoutes = ['/home', '/home/invoices', '/home/settings'];

      const currentUrl = this.router.url;

      const index = currentUrl.indexOf('/home');
      if (index === -1) return;

      const normalizedUrl = currentUrl.substring(index).split('?')[0];

      const shouldDisplay = allowedRoutes.includes(normalizedUrl);

      if (!shouldDisplay) {
        return;
      }

      this.alertService.success(
        'Les paramètres ont été mis à jour.<br>' +
          'La page se rafraîchira automatiquement dans 1 minute, ou vous pouvez :',
        {
          actionText: 'Rafraîchir maintenant',
          actionCallback: () => window.location.reload(),
        },
      );

      setTimeout(() => {
        this.refreshNow();
      }, 60_000);
    });
  }

  private listenAlertsUpdated() {
    this.websocketService.onAlertsUpdated().subscribe(() => {
      const allowedRoutes = ['/home/alerts'];

      const currentUrl = this.router.url;

      const index = currentUrl.indexOf('/home');
      if (index === -1) return;

      const normalizedUrl = currentUrl.substring(index).split('?')[0];

      const shouldDisplay = allowedRoutes.includes(normalizedUrl);

      if (!shouldDisplay) {
        return;
      }

      this.alertService.success(
        'Les alertes ont été mis à jour.<br>' +
          'La page se rafraîchira automatiquement dans 1 minute, ou vous pouvez :',
        {
          actionText: 'Rafraîchir maintenant',
          actionCallback: () => window.location.reload(),
        },
      );

      setTimeout(() => {
        this.refreshNow();
      }, 60_000);
    });
  }

  private listenContractsUpdated() {
    this.websocketService.onContractsUpdated().subscribe(() => {
      const allowedRoutes = ['/home/contracts'];

      const currentUrl = this.router.url;

      const index = currentUrl.indexOf('/home');
      if (index === -1) return;

      const normalizedUrl = currentUrl.substring(index).split('?')[0];

      const shouldDisplay = allowedRoutes.includes(normalizedUrl);

      if (!shouldDisplay) {
        return;
      }

      this.alertService.success(
        'Les contrats ont été mis à jour.<br>' +
          'La page se rafraîchira automatiquement dans 1 minute, ou vous pouvez :',
        {
          actionText: 'Rafraîchir maintenant',
          actionCallback: () => window.location.reload(),
        },
      );

      setTimeout(() => {
        this.refreshNow();
      }, 60_000);
    });
  }
}
